
import React,  {useEffect, useState, useCallback, createRef, useRef, useMemo, memo } from 'react';
import "react-select/dist/react-select.css";
import withTranslator from "../../Translator/withTranslation";
import withFosRouter from "../../FosRouter/withFosRouting";
import { compose } from "recompose";
import styled from "@emotion/styled";


const CountryBankSelectSwrapper = styled("div")`
    display:flex;
    width: max-content;
`;
const ListHeader = styled("div")`
    border: 1px solid #eee;
    padding: 0.5em 1em;
    border-radius: 3px;
    text-align: center;
    align-items: center;
    line-height:2em;
`;
const ListWrapper = styled("div")`
    
`;
const CountryListContainer = styled("div")`
    width: max-content;
    margin:0 5px;
`;
const ListItem = styled("li")`
  margin:0;
  list-style: none;
  padding: 0.5em;
  border-bottom: 1px solid #eeeeee;
  &:hover {
      background: #eeeeee;
  }
  cursor:pointer;
`;
const FlagContainer = styled("div")`
    max-width: max-content;
    display:flex;
    align-items: center;

`;
const Flag = styled("img")`
    width:32px;
    heigth:32px;
`;
const FlagLabel = styled("span")`
    margin-left: 1em;
`;

const CountryDropDownList = styled("ul")`
    padding: 0;
    margin: 0;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    color: #333333;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 3px;
    position: absolute;
    z-index: 10;
    left: -5px;
    top: 1px;
    align-items: center;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height:250px;
    width: max-content;
`;

const BankDropDownList = styled("ul")`
    padding: 0;
    margin: 0;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    color: #333333;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 3px;
    position: absolute;
    z-index: 10;
    top: 1px;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height:250px;
    width: max-content;
`;

const VoltCountryBankSelectComponent = (props) => {
    const [banksLoading, setBanksLoading] = useState(false);
    const [countriesLoading, setCountriesLoading] = useState(false);
    const [country, setCountry] = useState(JSON.parse(props.country));
    const [countries, setCountries] = useState([]);
    const [bank, setBank] = useState({});
    const [banks, setBanks] = useState([]);
    const countryRef = useRef(null);
    const bankRef = useRef(null);
    const wrapperRef = useRef(null);
    const [countryOpen, setCountryOpen] = useState(false);
    const [bankOpen, setBankOpen] = useState(false);
    const [voltPaymentEnabled, setVoltPaymentEnabled] = useState(false);

    useEffect(() => {
        updateCountries();
        var el = document.getElementById(props.paymentMethodId);
        if (el.checked) {
            setVoltPaymentEnabled(true);
        }

    },[]);

    const humanize = (property) => {
        if (property) {
        return property.replace(/_/g, ' ')
        .replace(/(\w+)/g, function(match) {
          return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
        });
        }

        return property;
    };

    const toggleVoltPayment = (e) => {
        if (e.target.checked === true && e.target.id === props.paymentMethodId) { 
            setVoltPaymentEnabled(true);
        } else {
            setVoltPaymentEnabled(false);
        }
    }
    useEffect(() => {
        var elements = document.querySelectorAll('input[name="cvrm_booking[paymentMethod]"]');

        elements.forEach((element) => element.addEventListener('click', toggleVoltPayment));
        return (elements) => {
            elements.forEach((element) => element.removeEventListener('click', toggleVoltPayment));
        };
    }, []);

    const updateCountries = () => {
        setCountriesLoading(true);
        fetch(props.r('volt_list_countries'))
        .then(response => response.json())
        .then(data => {
            setCountries(data);
            setCountriesLoading(false);
            if (country) { 
                updateBanks();
            }
        });
    }

    const updateBanks = () => {
        setBanks([]);
        setBanksLoading(true);

        var countryFilter ="";
        if (country) { 
            countryFilter = "?country_id=" + country.id;
        }
        fetch(props.r('volt_list_banks') + countryFilter)
        .then(response => response.json())
        .then(data => {
            setBanks(data);
            setBanksLoading(false);
        })
    }


    const onUpdateCountry = (country) => {
        var countryFilter ="";
        if (country) { 
            countryFilter = "?country_id=" + country.id;
        }
        setBanksLoading(true);
        fetch(props.r('volt_list_banks') + countryFilter)
        .then(response => response.json())
        .then(data => {
            // update list of banks
            setBanks(data);
            // reset selected bank 
            setBank({});
            setBanksLoading(false);
        });
        setCountry(country);
    }

    const onBankClicked = bank => () => {
        if (banksLoading) { 
            return;
        } 
        // update id holder of bank id
        setBank(bank);
        setBankOpen(false);
    }
    const onCountryClicked = country => () => {
        if (countriesLoading) { 
            return;
        }

        var countryFilter ="";
        if (country) { 
            countryFilter = "?country_id=" + country.id;
        }
        setBanksLoading(true);
        fetch(props.r('volt_list_banks') + countryFilter)
        .then(response => response.json())
        .then(data => {
            // update list of banks
            setBanks(data);
            // reset selected bank 
            setBank({});
            setBanksLoading(false);
            setBankOpen(true);
        });
        setCountry(country);
        setCountryOpen(false);
    }
    const toggleCountrySelect = () => {
        if (banksLoading || countriesLoading) {
            return;
        }
        setCountryOpen(!countryOpen);
        setBankOpen(false);

    }
    const toggleBankSelect = () => {
        if (banksLoading || countriesLoading) {
            return;
        }
        setBankOpen(!bankOpen);
        setCountryOpen(false);
    }
    return (
        <div className={voltPaymentEnabled ? "" : "hidden"}>
            <CountryBankSelectSwrapper className="country-bank-select-wrapper" ref={wrapperRef}>
                <ListWrapper className="country-list-wrapper">
                    <input ref={countryRef}  type="hidden" name="volt_country" value={country.id || ""} id="country" />
                    <ListHeader className="country-list-header" onClick={() => toggleCountrySelect()}>{countriesLoading && <img src="/assets/img/front/icons/loading-dots-blue123.gif" width="40" /> } {!countriesLoading && (humanize(country.name) && (
                                    <FlagContainer className="country-flag">
                                        <Flag src={ "https://www.countryflags.io/" + country.id + "/shiny/64.png" } />
                                        <FlagLabel className="country-name">{humanize(country.name)}</FlagLabel>
                                    </FlagContainer> ) || "Choose Country" )
                    }
                    </ListHeader>
                    { countryOpen && 
                        <CountryListContainer className="country-list-container">
                            <CountryDropDownList className="country-list">
                            { countries.length && countries.map((country) => (
                                <ListItem key={country.id} onClick={onCountryClicked(country)}>
                                    <FlagContainer className="country-flag">
                                        <Flag src={ "https://www.countryflags.io/" + country.id + "/shiny/64.png" } />
                                        <FlagLabel className="country-name">{humanize(country.name)}</FlagLabel>
                                    </FlagContainer>
                                </ListItem>
                                ))
                            }
                            </CountryDropDownList>
                        </CountryListContainer>
                    }
                </ListWrapper>
                { !countriesLoading && country.id !== "" &&
                <ListWrapper className="bank-list-wrapper pl-1">
                    <input ref={bankRef} type="hidden" name="volt_bank" value={bank.id || ""} id="bank" />
                    <ListHeader className="bank-list-header" onClick={() => toggleBankSelect()}>{banksLoading && <img src="/assets/img/front/icons/loading-dots-blue123.gif" width="40" /> } {!banksLoading && (humanize(bank.name) || "Choose Bank")}</ListHeader>
                    { bankOpen && banks.length > 0 &&
                        <div className="bank-list-container">
                            <BankDropDownList>
                            { banks.length && banks.map((bank) => (
                                <ListItem key={bank.id} onClick={onBankClicked(bank)}>
                                    <span className="bank-name">{humanize(bank.name)}</span>
                                </ListItem>
                                ))
                            }
                            </BankDropDownList>
                        </div>
                    }
                </ListWrapper>
                }
            </CountryBankSelectSwrapper>
        </div>
    );
}

export const VoltCountryBankSelect = compose(
    withTranslator,
    withFosRouter
)(VoltCountryBankSelectComponent);